var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsuranceProtectionSafetySvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7724 3.9199C17.2924 3.7599 14.8924 3.1999 12.4924 2.3999C10.1724 3.1999 7.77243 3.7599 5.21243 3.9199C4.81243 3.9999 4.49243 4.3199 4.49243 4.7199V13.5999C4.49243 15.9999 5.85243 18.2399 8.01243 19.3599L12.0924 21.4399C12.1724 21.5199 12.3324 21.5199 12.4124 21.5199C12.5724 21.5199 12.6524 21.5199 12.7324 21.4399L16.8124 19.3599C18.9724 18.2399 20.3324 16.0799 20.3324 13.5999V4.7199C20.4924 4.3199 20.1724 3.9999 19.7724 3.9199ZM16.2524 17.9199L12.4924 19.8399V11.9999H6.09243V5.5199C8.25243 5.2799 10.4124 4.7999 12.4924 4.1599V11.9999H18.8924V13.6799C18.8924 15.4399 17.8524 17.1199 16.2524 17.9199Z",
    fill: "#5D2EDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceProtectionSafetySvgrepoCom1);
export default __webpack_public_path__ + "static/media/insurance-protection-safety-svgrepo-com 1.58cf1b907e4fa6cd4b000cd4b80628c4.svg";
export { ForwardRef as ReactComponent };